import { inject } from '@angular/core';
import { type CanActivateFn, type CanMatchFn, Router } from '@angular/router';
import { MtmAuthBridgeService, MTM_LOGIN_ROUTE } from '@mtm/auth-ui-angular';

export const authGuard: CanMatchFn = () => {
  const bridge = inject(MtmAuthBridgeService);
  const router = inject(Router);
  const loginRoute = inject(MTM_LOGIN_ROUTE);
  if (bridge.isAuthenticated()) return true;
  return router.createUrlTree([loginRoute]);
};

export const loginGuard: CanActivateFn = () => {
  const bridge = inject(MtmAuthBridgeService);
  const router = inject(Router);
  if (!bridge.isAuthenticated()) return true;
  return router.createUrlTree(['/tenants']);
};

export const tenantSelectGuard: CanActivateFn = () => {
  const bridge = inject(MtmAuthBridgeService);
  const router = inject(Router);
  if (bridge.getAppTokenSync()) return router.createUrlTree(['/tenants']);
  if (bridge.isAuthenticated()) return true;
  return router.createUrlTree(['/login']);
};
